import { ILease1099 } from 'src/models/dlcLease/ILeaseMaster';

export interface ILeaseTinNameAddress {
    tin?: string;
    name1?: string;
    name2?: string;
    name3?: string;
    addr1?: string;
    addr2?: string;
    cstz?: string;
}

export const nameAddressFields = ['name1', 'name2', 'name3', 'addr1', 'addr2', 'cstz'] as const;
export type LeaseNameAddress = Pick<ILease1099, typeof nameAddressFields[number]>;
export const getNameAddress = (record: LeaseNameAddress): LeaseNameAddress => ({
    name1: record.name1 || '',
    name2: record.name2 || '',
    name3: record.name3 || '',
    addr1: record.addr1 || '',
    addr2: record.addr2 || '',
    cstz: record.cstz || '',
});

export type TinNameAddressMatchResult = 'match' | 'mismatch' | 'missing';

export const normalizeTin = (value?: string | null): string => (value || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();

export const normalizeTinMatchText = (value?: string | null): string => (value || '').trim().replace(/\s+/g, ' ').toUpperCase();

/**
 * Mirrors the CALMS comparison against the LEASE_TINS maintenance header.
 * Formatting differences in the TIN and insignificant text casing/spacing do
 * not constitute a mismatch.
 */
export const isTinNameAddressMatch = (lease1099: ILease1099, maintenance: ILeaseTinNameAddress): boolean => {
    const leaseTin = normalizeTin(lease1099.ssn);
    const maintenanceTin = normalizeTin(maintenance.tin);

    if (!leaseTin || !maintenanceTin || leaseTin !== maintenanceTin) {
        return false;
    }

    return nameAddressFields.every((key) => normalizeTinMatchText(lease1099[key]) === normalizeTinMatchText(maintenance[key]));
};

export const getTinNameAddressMatchResult = (lease1099: ILease1099, maintenance?: ILeaseTinNameAddress | null): TinNameAddressMatchResult => {
    if (!maintenance) {
        return 'missing';
    }

    return isTinNameAddressMatch(lease1099, maintenance) ? 'match' : 'mismatch';
};



// WEBPACK FOOTER //
// ./src/components/leases/sections/tinNameAddressMatching.ts